<app-gifter-detail
    *ngIf="selectedGifter"
    [selectedGifter]="selectedGifter"
    [selectedGifterInfo]="selectedGifterInfo"
    (close)="closeGifterDetail()"
></app-gifter-detail>
